import { render, staticRenderFns } from "./rekonsales.vue?vue&type=template&id=27a3bbe2&scoped=true"
import script from "./rekonsales.vue?vue&type=script&lang=js"
export * from "./rekonsales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a3bbe2",
  null
  
)

export default component.exports